import { useCommitees } from '@/api/commitee/commitee.queries';
import { useCommiteeSlugFromUrl, useCommiteeSlugNavigate } from '@/utils/router';
import { slugify } from '@/utils/string.utils';
import { Combobox } from './Combobox';
import { ShadcnSidebarGroup, ShadcnSidebarGroupContent } from './shadcn/Sidebar';

type CompanySelectorProps = {
  isAdmin: boolean;
};

export function CompanySelector({ isAdmin }: CompanySelectorProps) {
  const { data: commitees, isLoading } = useCommitees();
  const commiteeSlugFromUrl = useCommiteeSlugFromUrl();
  const navigateWithCommiteeSlug = useCommiteeSlugNavigate();

  if (!isAdmin) {
    return null;
  }

  return (
    <ShadcnSidebarGroup>
      <ShadcnSidebarGroupContent>
        <div className="px-2 py-2">
          <Combobox
            options={
              commitees?.map((commitee) => ({
                value: slugify(commitee.name),
                label: commitee.name,
              })) || []
            }
            value={commiteeSlugFromUrl || ''}
            onChange={(value) => {
              navigateWithCommiteeSlug({
                to: '/$commiteeSlug',
                params: { commiteeSlug: value as string },
              });
            }}
            isLoading={isLoading}
          />
        </div>
      </ShadcnSidebarGroupContent>
    </ShadcnSidebarGroup>
  );
}
